import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Touch } from 'vuetify/lib/directives';
import VHover from 'vuetify';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

Vue.use(Vuetify, {
  components: VHover,
  directives: {
    Touch,
  },
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#FA5E15',
        secondary: '#FFFFFF',
        graymain: '#CCCCCC',
        accent: '#66AFED',
        accentdarker: '#3D9BE8',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        graylight: '#f8f8f8',
        graylighter: '#f1f1f1',
        graydark: '#333333',
        graybackground: '#c7c7c7',
        grayappbar: '#EDEDED',
      },
      dark: {
        primary: '#FA5E15',
        secondary: '#FFFFFF',
        graymain: '#CCCCCC',
        accent: '#66AFED',
        accentdarker: '#3D9BE8',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        graylight: '#F8F8F8',
        graydark: '#333333',
        graybackground: '#c7c7c7',
      },
    },
  },
});
